import { NotesManagerContent } from "@/features/notes-manager";
import { DEFAULT_NOTE_TYPES } from "@/services/api";
import { ResponsiveBlockSwitcher } from "@/shared/Components";
import { IdeasTab as IdeasTabMobile } from "@/pages/ContactsPage/Tabs/ideas-tab";
import { useNotesManager } from "../model";

export const IdeasTab = () => {
  const notesManager = useNotesManager();

  return (
    <ResponsiveBlockSwitcher
      desktop={
        <NotesManagerContent
          notesManager={notesManager}
          noteType={DEFAULT_NOTE_TYPES.DEFAULT_IDEA}
          contactsPage
        />
      }
      mobile={<IdeasTabMobile />}
    />
  );
};
